var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TokenType = function () {
  function TokenType(type, lexeme, value) {
    _classCallCheck(this, TokenType);

    this.lexeme = lexeme;
    this.value = value;
    this.type = type;
  }

  _createClass(TokenType, [{
    key: 'match',
    value: function match() {
      var _this = this;

      for (var _len = arguments.length, types = Array(_len), _key = 0; _key < _len; _key++) {
        types[_key] = arguments[_key];
      }

      return types.findIndex(function (type) {
        return _this.type === type;
      }) !== -1;
    }
  }]);

  return TokenType;
}();

export default TokenType;


export var types = {
  EOF: '@type/eof',
  DOT: '@type/dot',
  CONSTANT: '@type/constant',
  IDENTIFIER: '@type/identifier',

  LOGICAL_EQUALITY: '@type/logical-equality',
  LOGICAL_CONDITION: '@type/logical-condition',

  LOGICAL_OR: '@type/logical-or',
  LOGICAL_AND: '@type/logical-and',
  LOGICAL_NEGATION: '@type/logical-negation',

  ADD_SUBTRACT: '@type/add-subtract',
  INCREASE_DECREASE: '@type/increase-decrease',
  MULTIPLY_DIVIDE: '@type/multiply-divide',

  OPEN_PARENTHESES: '@type/open-parentheses',
  CLOSE_PARENTHESES: '@type/close-parentheses',

  OPEN_SQUARE_BRACKET: '@type/open-square-bracket',
  CLOSE_SQUARE_BRACKET: '@type/close-square-bracket',

  DELIMITER: '@type/delimiter'
};